import { extractInvokeErrorMessage } from './groovesStripeService.js';

/** Mensaje legible tras `supabase.functions.invoke('admin-actions', …)`. */
export async function resolveAdminInvokeError(error, data, fallback = 'Error en la operación.') {
  if (data && typeof data === 'object') {
    if (data.message != null && String(data.message).trim()) {
      return String(data.message);
    }
    const errKey = data.error != null ? String(data.error) : '';
    if (errKey === 'image_persist_failed') {
      return 'No se pudo guardar la imagen en el servidor. Sube la imagen manualmente (Borradores → Subir imagen) o corrige la URL externa.';
    }
    if (errKey === 'server_misconfigured') {
      return 'Configuración del servidor incompleta. Contacta con soporte técnico.';
    }
    if (errKey && errKey !== 'action_failed') {
      return errKey.replace(/_/g, ' ');
    }
  }
  if (error) {
    const msg = await extractInvokeErrorMessage(error);
    if (/edge function returned a non-2xx/i.test(msg)) {
      return fallback;
    }
    return msg;
  }
  return fallback;
}
